// Angular Imports
import { Component, OnInit, Input, Injector } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Component imports
import { MPSearchBaseComponent } from '../_base/mp-base-search.component';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { SearchService } from '../_services/data-services/search.service';

// Model imports
import { SearchParametersDto } from '../_models/search-parameters-dto';
import { VendorSearchResultDto } from '../_models/vendors-search-result-dto';

@Component({
    selector: 'app-search-vendors',
    templateUrl: './search-vendors.component.html',
    styleUrls: ['./search-vendors.component.scss']
})
export class SearchVendorsComponent extends MPSearchBaseComponent implements OnInit {
    @Input() communityId: number;

    vendors: VendorSearchResultDto[] = [];

    iconCheck = IconConstants.CHECK;
    iconClose = IconConstants.CLOSE;

    showSearchPanel = false;

    constructor(
        protected readonly injector: Injector,
        private readonly errorService: ServerErrorService,
        private readonly searchService: SearchService
    ) {
        super(injector);
    }

    ngOnInit() {
        if (!!this.searchText) {
            this.searchVendors();
        }
    }

    getFileIcon(record: VendorSearchResultDto): string {
        const fileName = Utils.notNullAndDefined(record.w9FileInfo) ? record.w9FileInfo.fileName : '';
        return Utils.notNullOrEmpty(fileName) ? this.helperService.getFileIconByExtension(fileName) : '';
    }

    getCommunityId(groupdata): number {
        let communityId = null;
        if (!!groupdata && !!groupdata.items && groupdata.items.length > 0) {
            communityId = groupdata.items[0].communityId;
        } else if (!!groupdata && !!groupdata.collapsedItems && groupdata.collapsedItems.length > 0) {
            communityId = groupdata.collapsedItems[0].communityId;
        }
        return communityId;
    }

    downloadFile(data: VendorSearchResultDto): void {
        if (!!data) {
            this.helperService.downloadFileUsingUrl(data.w9FileInfo.downloadUrl, data.w9FileInfo.fileName);
        }
    }

    public searchVendors() {
        const param: SearchParametersDto = new SearchParametersDto();
        param.clearCache = true;
        param.searchText = this.searchText;
        param.communityId = this.communityId;

        this.vendors = [];
        this.loadingVisible = true;
        this.searchService.searchVendors(param).subscribe(
            (data) => {
                this.vendors = data;
                this.updateGridSearchStatus(data);
                this.loadingVisible = false;

                this.showSearchPanel = true;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
